// src/components/OfflineIndicator.tsx
import { Logs,WifiOff } from 'lucide-react';
import { useEffect,useState } from 'react';

import { getKVStatus } from '@/lib/storage/kv-client.ts'; // Import your KV client

export const OfflineIndicator = () => {
  const [showIndicator, setShowIndicator] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [status, setStatus] = useState({
    isOnline: true,
    queueSize: 0
  });

  useEffect(() => {
    setShowIndicator(true);

    // Function to update status
    const updateStatus = async () => {
      try {
        const kvStatus = await getKVStatus();
        setStatus({
          isOnline: kvStatus.isOnline,
          queueSize: kvStatus.queueSize
        });
      } catch (error) {
        console.error('Failed to fetch KV status:', error);
      }
    };

    // Initial status check
    updateStatus();

    // Listen to online/offline events
    const handleOnline = () => {
      console.log('🟢 Online event detected in OfflineIndicator');
      updateStatus();
    };

    const handleOffline = () => {
      console.log('🔴 Offline event detected in OfflineIndicator');
      updateStatus();
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Poll queue size less frequently (only when online and has pending items)
    const queueCheckInterval = setInterval(() => {
      if (navigator.onLine || status.queueSize > 0) {
        updateStatus();
      }
    }, 10000); // Check every 10 seconds instead of 5

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
      clearInterval(queueCheckInterval);
    };
  }, [status.queueSize]);

  // Hide if not ready or if online with empty queue
  if (!showIndicator || (status.isOnline && status.queueSize === 0)) return null;

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <div className="fixed bottom-4 left-4 z-50">
      <div
        onClick={toggleCollapse}
        className={`
          cursor-pointer
          transition-all
          duration-200
          shadow-lg
          rounded-md
          border
          border-border
          bg-background
          hover:bg-muted
          flex
          items-center
          gap-1
          ${isCollapsed ? 'p-1' : 'py-1 px-2'}
        `}
      >
        {!status.isOnline ? (
          <>
            <WifiOff className="h-4 w-4 text-destructive" />
            {!isCollapsed && (
              <span className="text-sm font-medium whitespace-nowrap text-foreground">
                Offline
                {status.queueSize > 0 && ` • ${status.queueSize}`}
              </span>
            )}
          </>
        ) : (
          <>
            <Logs className="h-4 w-4 text-primary" />
            {!isCollapsed && (
              <span className="text-sm font-medium whitespace-nowrap text-foreground">
                {status.queueSize}
              </span>
            )}
          </>
        )}
      </div>
    </div>
  );
};